import { useState, useEffect, useCallback } from 'react';
import GridExpandableAtom from '@components/atom/grid/gridExpandable';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { fetchAlertList, fetchAlertEnable, fetchAlertHistoryList } from '@reducers/account/thunks/alertThunk';
import { setAlertBoxType } from '@reducers/account/alertSlice';
import { AlertOption } from '@classes/options/grid/account/alertGridOption';
import { alertTypeObj } from '@models/manager/account/account';
import { IAlertList } from '@models/manager/account/accountModel';
import ExpandableListBox from './expandableListBox';

const AlertList = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { alertList } = useSelector(({ alert }: RootState) => alert);

  const [gridChartOption, setGridChartOption] = useState(null);

  // 초기요청
  useEffect(() => {
    dispatch(fetchAlertList());
  }, []);

  // alertList 있을때 차트 적용!
  useEffect(() => {
    if (alertList) {
      setGridChartOption(new AlertOption().alertList(alertList, onClickEnable, onClickHistory));
    }
  }, [alertList]);

  // 그리드차트 내부 토글 버튼
  const onClickEnable = useCallback(
    (rowObj) => {
      console.log('rowObj: ', rowObj);
      const alertMessage = !rowObj.enable
        ? `Do you want to enable ${rowObj.alertName}`
        : `Do you want to disable ${rowObj.alertName}`;
      if (confirm(alertMessage)) {
        // 아래의 dispatch 를 통해 post 요청후 리덕스에서 변경처리함
        // (위의 useEffect 에서 그리드데이터 업데이트처리)
        dispatch(fetchAlertEnable({ alertId: rowObj.id, enable: rowObj.enable }));
      }
    },
    [dispatch, fetchAlertEnable]
  );
  const onClickHistory = useCallback(
    (rowObj: IAlertList) => {
      // 여기서 선택한 alertId의 History 정보 가져오기
      dispatch(fetchAlertHistoryList({ alertId: rowObj.id }));
      dispatch(setAlertBoxType({ boxType: alertTypeObj.historyBox }));
    },
    [dispatch, setAlertBoxType, alertTypeObj, fetchAlertHistoryList]
  );

  const onClickCreateAlert = useCallback(() => {
    dispatch(setAlertBoxType({ boxType: alertTypeObj.createBox }));
  }, [dispatch, setAlertBoxType, alertTypeObj]);

  return (
    <>
      <div className="account-header">
        <h2 className="account-tit">Alert List</h2>
        <button type="button" className="btn-s pri" onClick={onClickCreateAlert}>
          <span>+</span>
          Create Alert
        </button>
      </div>
      <div className="tb-basic-wrap">
        <GridExpandableAtom {...gridChartOption} ExpandedComponent={ExpandableListBox} height={'600px'} />
      </div>
    </>
  );
};

export default AlertList;
